import { pdf } from "@react-pdf/renderer";
import { PDFConvenio } from "./convenioPdfGenerator";
import { calcularMontoArray } from "../../../../utils/utils";
import { actuacionesService } from "../../../../_services/actuaciones.service";
import { convenioService } from "../../../../_services/convenios.service";
import Pako from "pako";
import { PDFConvenioOld } from "./convenioPdfGeneratorOld";

export const generarDescargarPDFConvenio = async (convenioId) => {
  const convenio = await getConvenioID(convenioId);
  const radicacion = await getRadicacion(convenio);
  const montoTotal = calcularMontoArray(convenio?.convenio_convpp, "monto");
  const montoInteres = calcularMontoArray(convenio?.convenio_convpp, "montoInteres");
  const montoOrigen = calcularMontoArray(convenio?.convenio_convpp, "montoOrigen");
  const honorarios = (montoTotal * convenio.estporc) + convenio.estgstfijo + convenio.otgastos;
  const fechaActual = getFechaActual(convenio);
  const blob = parseInt(convenioId) > 14126
    ? await pdf(<PDFConvenio 
      convenio = { convenio }
      radicacion = { radicacion }
      montoTotal = { montoTotal }
      montoOrigen = { montoOrigen }
      montoInteres = { montoInteres }
      honorarios = { honorarios }
      fechaActual = { fechaActual }
    />).toBlob()
    : await pdf(<PDFConvenioOld
      convenio = { convenio }
      radicacion = { radicacion }
      montoTotal = { montoTotal }
      honorarios = { honorarios }
      fechaActual = { fechaActual }
    />
    ).toBlob();
  
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `Convenio_${convenioId}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const getConvenioID = async (convenioId) => {
  return await convenioService.getConvenioById(convenioId);
};

const getRadicacion = async (convenio) => {
  const imponibles = convenio?.convenio_convpp.map(({ imponible, recurso }) => {
    return {
      abogado: convenio?.convenio_abogado?.codexterno,
      imponible,
      recurso
    };
  });
  const causa = Pako.gzip(JSON.stringify(imponibles));
  const radicacionResponse = await actuacionesService.getRadicacion({data: causa, fecha: convenio.fechacarga});
  return radicacionResponse.length ? radicacionResponse[0].etapas[0].etp01 : null;
};

// const getFechaActual = (convenio) => {
//   console.log(convenio.fechaconf);
//   // const dia = new Date(convenio.fechaconf).getUTCDay();
//   const dia = new Date(convenio.fechaconf).getDay();
//   const mesStr = new Date(convenio.fechaconf).toLocaleString("ART", { month: "long" });
//   const mesInt = new Date(convenio.fechaconf).getUTCMonth();
//   const anio = new Date(convenio.fechaconf).getUTCFullYear();
//   console.log({
//     dia,
//     mesStr,
//     mesInt,
//     anio
//   });
//   return {
//     dia,
//     mesStr,
//     mesInt,
//     anio
//   };
// };

const getFechaActual = (convenio) => {
  const [anio, mes, dia] = convenio.fechaconf.split("-").map(Number);
  
  const fecha = new Date(anio, mes - 1, dia); // <-- mes empieza en 0
  
  const mesStr = fecha.toLocaleString("es-AR", { month: "long" });

  return {
    dia,
    mesStr,
    mesInt: mes,
    anio
  };
};